<template>
  <span :class="{ 'a-visually-hidden': !isVisible }" :lang="label.language">
    {{ label.label }}<slot />
  </span>
</template>

<script setup>
import { useLabelsStore } from '@stores/labels';
import { toRefs, computed } from 'vue';

const store = useLabelsStore();
const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
  path: {
    type: String,
    required: true,
  },
  replace: {
    type: Object,
    default: undefined,
  },
});

const { path, replace } = toRefs(props);

const label = computed(() => {
  const result = store.get({ path: path.value });
  if (replace.value) {
    Object.entries(replace.value).forEach(([key, value]) => {
      result.label = result.label.replace(key, value);
    });
  }
  return result;
});
</script>
